import { render, staticRenderFns } from "./CreateTaxCode.vue?vue&type=template&id=5a0fe8f6&scoped=true&"
import script from "./CreateTaxCode.vue?vue&type=script&lang=js&"
export * from "./CreateTaxCode.vue?vue&type=script&lang=js&"
import style0 from "./CreateTaxCode.vue?vue&type=style&index=0&id=5a0fe8f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0fe8f6",
  null
  
)

export default component.exports